
import React from "react";
import { Table, TableBody } from "@/components/ui/table";
import { ReportsPagination } from "@/components/reports/ReportsPagination";
import { WorksheetEditDialog } from "./WorksheetEditDialog";
import { WorksheetCreateDialog } from "./WorksheetCreateDialog";
import { WorksheetTableHeader } from "./WorksheetTableHeader";
import { WorksheetTableRow } from "./WorksheetTableRow";
import { WorksheetSearch } from "./WorksheetSearch";
import { WorksheetEmpty } from "./WorksheetEmpty";
import { WorksheetLoading } from "./WorksheetLoading";
import { useWorksheetTable } from "./useWorksheetTable";

export const WorksheetManagementTable: React.FC = () => {
  const {
    worksheets,
    isLoading,
    currentPage,
    setCurrentPage,
    totalPages,
    searchQuery,
    setSearchQuery,
    sortField,
    sortDirection,
    handleSort,
    subjectFilter,
    setSubjectFilter,
    subjects,
    editingWorksheet,
    isEditDialogOpen,
    setIsEditDialogOpen,
    isCreateDialogOpen,
    setIsCreateDialogOpen,
    formatDate,
    handleEditClick,
    handleSaveEdit,
    handleCreateWorksheet,
    handleDeleteWorksheet
  } = useWorksheetTable(20); // 20 items per page

  return (
    <div className="space-y-4">
      {/* Filters and search */}
      <WorksheetSearch 
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        subjectFilter={subjectFilter}
        setSubjectFilter={setSubjectFilter}
        subjects={subjects}
        onCreateClick={() => setIsCreateDialogOpen(true)}
      />
      
      {/* Worksheets Table */}
      <div className="rounded-md border overflow-hidden">
        <Table>
          <WorksheetTableHeader 
            sortField={sortField}
            sortDirection={sortDirection}
            handleSort={handleSort}
          />
          
          <TableBody>
            {isLoading ? (
              <WorksheetLoading />
            ) : worksheets.length > 0 ? (
              worksheets.map((worksheet) => (
                <WorksheetTableRow
                  key={worksheet.id}
                  worksheet={worksheet}
                  onEditClick={handleEditClick}
                  onDeleteClick={handleDeleteWorksheet}
                  formatDate={formatDate}
                />
              ))
            ) : (
              <WorksheetEmpty />
            )}
          </TableBody>
        </Table>
      </div>
      
      {/* Pagination */}
      {totalPages > 1 && (
        <div className="flex justify-center mt-6">
          <ReportsPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={(page) => setCurrentPage(page)}
          />
        </div>
      )}
      
      {/* Edit Dialog */}
      <WorksheetEditDialog
        isOpen={isEditDialogOpen}
        setIsOpen={setIsEditDialogOpen}
        worksheet={editingWorksheet}
        onSave={handleSaveEdit}
      />
      
      {/* Create Dialog */}
      <WorksheetCreateDialog
        isOpen={isCreateDialogOpen}
        setIsOpen={setIsCreateDialogOpen}
        onSave={handleCreateWorksheet}
      />
    </div>
  );
};
